import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationMenu from '../components/shared/NavigationMenu';
import Tooltip from '../components/atoms/Tooltip/Tooltip';
import { useSidebar } from '../contexts/SidebarContext';
import billingService from '../services/billing';
import './Sidebar.css';

const getInitials = (name) => {
  if (!name) return 'U';
  return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
};

const Sidebar = ({ user, isInsideProject = false }) => {
  const { isExpanded, toggleSidebar } = useSidebar();
  const navigate = useNavigate();
  const [planName, setPlanName] = useState(null);

  useEffect(() => {
    if (!isInsideProject) return;
    let mounted = true;
    const loadPlan = async () => {
      try {
        const billingData = await billingService.getBillingInfo();
        const subscription = billingService.formatSubscription(billingData.subscription);
        if (mounted && subscription?.plan) {
          setPlanName(subscription.plan.name);
        }
      } catch (e) {
        // ignore
      }
    };
    loadPlan();
    return () => { mounted = false; };
  }, [isInsideProject]);

  return (
    <aside className={`app-sidebar ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="sidebar-content">
        <div className="sidebar-header">
          {user && isExpanded && (
            <div className="sidebar-user">
              <div className="user-info">
                <h3 className="user-name">{user.name || 'User'}</h3>
                <p className="user-plan">{user.email}</p>
              </div>
            </div>
          )}
          <Tooltip content="⌘+B" position="bottom">
            <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5-1v12h9a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM4 2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2z"/>
              </svg>
            </button>
          </Tooltip>
        </div>

        <NavigationMenu collapsed={!isExpanded} />

        {isInsideProject && user && (
          <div
            className={`sidebar-bottom ${isExpanded ? '' : 'sidebar-bottom--collapsed'}`}
            onClick={() => navigate('/billing')}
            style={{ cursor: 'pointer' }}
          >
            <div className={`sidebar-bottom-avatar avatar-${getInitials(user.name || user.email)?.[0]?.toUpperCase() || 'U'}`}>
              {getInitials(user.name || user.email)}
            </div>
            {isExpanded && (
              <div className="sidebar-bottom-info">
                <span className="sidebar-bottom-name">{user.name || 'User'}</span>
                {planName && <span className="sidebar-bottom-plan">{planName} Plan</span>}
              </div>
            )}
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
